///
/// EarthBrowser
///
/// Created by Matt Giger on 9/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Scene-state application shared by saved-view fly-to and story stops:
/// enable-only layer dependencies and ?target= entity refocus.
///

import { engineActions, engineBridge } from "@/earthbrowser/engineBridge"
import type { DatasetType } from "@/types/DatasetElement"
import { parseTarget } from "@/utils/navigationHistory"

/** Enable a scene's layer dependencies; never disables anything */
export function enableSceneLayers(layers?: string[]): void {
	if (!layers || layers.length === 0) return
	const visible = engineBridge.getState()?.earthbrowser.visibleDatasets ?? []
	for (const layer of layers) {
		if (!visible.includes(layer as DatasetType)) {
			engineBridge.dispatch({ type: engineActions.sendDatasetAction, payload: { type: layer as DatasetType, action: "enable" } })
		}
	}
}

/** Refocus the entity a scene was saved with; false if unparseable */
export function focusSceneTarget(target: string): boolean {
	const parsed = parseTarget(target)
	if (!parsed) return false

	if (parsed.kind === "entity") {
		engineBridge.dispatch({ type: engineActions.sendDatasetAction, payload: { type: parsed.type, action: "selectId", id: parsed.id } })
	} else {
		engineBridge.dispatch({
			type: engineActions.sendDatasetAction,
			payload: {
				type: "location",
				action: "selectCoords",
				id: "0",
				lat: parsed.lat,
				lon: parsed.lon,
				name: parsed.name,
			}
		})
	}
	return true
}
